export default {"src":"/_next/static/media/Maestro.f38a90ea.svg","height":707,"width":1134,"blurWidth":0,"blurHeight":0};